// Estatutos de cobrança que o painel FILTRA (abas, `Select` mobile, `search` da rota).
//
// Local à feature, não reexportado de `kit/tx-status.tsx`: o Zenith não usa
// nenhum componente do kit na tela (`brief-web-tela-zenith.md`), e a lista de status é
// diferente da do kit em um ponto (API-30, Caio 17/09): `expired` some do painel, a API
// nem aceita mais `status=expired` (400). `kit/tx-status.tsx` continua com os
// 6 valores porque `admin-transactions` (fora desta task) ainda o usa.
//
// A cor/rótulo de exibição vem de `components/app/tx-status-badge.tsx` (WEB-101), que já
// cobre estes 5 valores sem `expired`. Este arquivo só resolve "quais status a lista pode
// filtrar", não como pintar um status.

export const TRANSACTION_STATUS_FILTERS = [
  'paid',
  'pending',
  'failed',
  'refunded',
  'chargeback',
] as const;

export type TransactionStatusFilter = (typeof TRANSACTION_STATUS_FILTERS)[number];

export function isTransactionStatusFilter(value: unknown): value is TransactionStatusFilter {
  return TRANSACTION_STATUS_FILTERS.some((status) => status === value);
}

/** Rótulo pt-BR das abas (croqui `screens/seller/transacoes.tsx`), no plural. */
export const TRANSACTION_STATUS_FILTER_LABEL: Record<TransactionStatusFilter, string> = {
  paid: 'Pagas',
  pending: 'Aguardando',
  failed: 'Falhas',
  refunded: 'Estornadas',
  chargeback: 'Chargeback',
};

/** `provider_status` da cobrança internacional (texto livre do adquirente): rotula só o que conhecemos. */
const INTL_PROVIDER_STATUS_LABEL: Record<string, string> = {
  pending: 'Aguardando o comprador',
  authorized: 'Autorizada',
  liquidated: 'Liquidada',
  refused: 'Recusada',
  refunded: 'Estornada',
  chargeback: 'Chargeback',
};

export function intlProviderStatusLabel(status: string): string {
  return INTL_PROVIDER_STATUS_LABEL[status.toLowerCase()] ?? status;
}
